// extracted by mini-css-extract-plugin
export default {"product_container":"Productlist_product_container__i4yez","sort_container":"Productlist_sort_container__kDhGd","products_box":"Productlist_products_box__RfX1t"};